<template>
  <div style="display: inline-block">
    <!-- <v-btn
      color="grey lighten"
      outline
      v-if="selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'"
    >
      {{ $t('Conversation Templates') }}
      <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
    </v-btn> -->
    <v-btn color="primary" @click="openModal" outline>
      {{ $t('Conversation Templates') }}
    </v-btn>
    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-premium-plan-popup
          text="You don't have to create your conversations anymore. Includes popular questions. One click can create conversation. Starting at 500 baht/month. Upgrade now!"
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
        ></v-premium-plan-popup>
        <v-btn icon style="position: absolute; right: 5px; z-index: 201;">
          <v-icon @click="showTransfer = false">close</v-icon>
        </v-btn>
        <v-card-title>
          <span class="mr-3" style="font-size: 16px;">{{
            $t('Select the template topic you want to add.')
          }}</span>
          <div class="form-control">
            <input
              type="text"
              :placeholder="$t('Find a conversation.')"
              v-model="search"
              maxlength="255"
            />
          </div>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="pa-0">
          <div v-if="loading" class="spinner text-xs-center mt-2 mb-2">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <div class="mt-4 mb-4">
            <v-layout row wrap>
              <v-flex
                xs6
                sm4
                class="pa-1"
                v-for="(item, index) in filterTemplateIntent"
                :key="index"
              >
                <v-card outline>
                  <v-card-title>
                    <div style="width: 100%;">
                      <span class="icon">{{ item.icon }}</span>
                      <v-chip v-if="item.chip" class="chip">{{ item.chip }}</v-chip>

                      <div class="mt-4">
                        <span class="mb-0" style="font-weight: bold;">{{ $t(item.label) }} </span>
                        <small class="small" v-if="item.new"> {{ $t('New') }}</small>
                      </div>
                      <small v-if="item.count !== 0"
                        >{{ item.count }} {{ $t('Automatic question') }}</small
                      >
                      <v-btn
                        style="float: right;"
                        outline
                        text
                        small
                        color="primary"
                        @click="select(item.intent)"
                        class="pa-1 "
                      >
                        {{ $t('Select') }}
                      </v-btn>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['type', 'intents'],
  data: () => {
    return {
      search: '',
      showTransfer: false,
      currentPage: null,
      loading: true,
      templateIntent: [
        {
          id: 1,
          count: 70,
          icon: '🛒',
          chip: '',
          label: 'Interested/Order',
          new: true,
          intent: [
            {
              intentname: 'Template_สั่งซื้อสินค้า',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ขอสั่งซื้อ1ชุดครับ,สั่งซื้อสินค้า,ต้องสั่งซื้อยังไงครับ,ขอดูสินค้าทั้งหมดหน่อยค่ะ,ขอดูสินค้าคะ,ต้องการเลือกสินค้าค่ะ,มีสินค้าอยู่ไหมคะ,สั่งสินค้าหน่อยค่า,ขอดูสินค้า,ยังมีสินค้านี้ยุมั้ยค่ะ,สนใจสินค้า,สนใจสินค้าทางร้านค่ะ,สามารถเลือกดูสินค้าได้จากลิงก์เลยใช่มั้ยคะ,ขอดูสินค้าที่มีด้วยนะค่ะเพื่อนจะสั่งค่ะ,ดูสินค้าตรงไหนคะ,มีสินค้าแบบใหม่ไหมคะ,สั่งซื้อสินค้า,สินค้าพร้อมส่งใช่ไหมคะ,ขอดูสินค้าหน่อยค่ะ,สนใจสั่งสินค้าค่ะ,สินค้าจะมีลายใหม่มาลงมั้ยคะ,เลือกสินค้าในนี้ได้เลยใช่มั๊ยคะ,ขอดูสินค้าหน่อยคะ,ขอดูแบบสินค้าคะ,ถ้าจะรบกวนขอรูปสินค้าได้มั้ยคะ,ยังมีสินค้าไหมคะ,ยังมีสินค้ามั้ยคะ,สั่งสินค้าเพิ่มได้ไหมค่ะ,สั่งสินค้าได้ทางไหนค่ะ,สินค้าตัวไหนพร้อมส่ง,ยังมีสินค้าไหมคะ,สนใจสินค้า,สนใจสินค้าค่ะ,มีสินค้าพร้อมส่งไหมคะ,ขอดูสินค้าได้ไหมค่ะ,สนใจสินค้าค่ะ,สั่งสินค้าค่ะ,สนใจสินค้า,สนใจสอบถามคะ,includes(สนใจ&&สั่งซื้อ),includes(สั่ง&&ยังไง),includes(สั่ง&&อย่างไร),includes(ซื้อ&&สินค้า),includes(สนใจ&&สั่ง),includes(ต้องการ&&สั่ง),includes(สั่ง&&ทางไหน),includes(สั่ง&&ที่ไหน),includes(สนใจ&&ซื้อ),includes(ซื้อ&&สินค้า),includes(สอบถาม&&ซื้อ),includes(ซื้อ&&ยัง),exacts(สนใจสั่งซื้อ),exacts(สั่งซื้อสินค้า),exacts(ดูสินค้าทั้งหมด)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 2,
          count: 55,
          icon: '🎊',
          chip: '',
          label: 'Promotion',
          new: true,
          intent: [
            {
              intentname: 'Template_โปรโมชั่น',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'มีโปรอะไรบ้าง,มีโปรโมชั่นอะไรบ้างคะ,มีโปรโมชั่นอะไรบ้าง,มีPromotionอะไรบ้างขอโปรโมชั่นหน่อยค่ะ,แนะนำโปรโมชั่นหน่อยค่ะ,มีโปรอะไรแนะนำไหมคะ,มีโปรโมชั่นบ้างไหนคะ,มีโปรไหมคะตอนนี้,มีโปรอะไรบ้างคะ,ตอนนี้มีโปรอะไรบ้างคะ,มีโปรแนะนำไหมคะ,จัดโปรไหมคะตอนนี้,ช่วงนี้มีโปรไหมคะ,มีส่วนลดมั้ยคะ,มีโปรโมชั่นอะไรไหมคะ,ช่วงนี้มีโปรอะไรบ้างคะ,ดูโปรโมชั่นปัจจุบัน,โปรโมชั่นทั้งหมด,มีโปรอะไรไหมคะ,มีโปรไหมคะ,มีโปรมั้ยคะ,ตอนนี้มีโปรโมชั่นอะไรบ้างคะ,ขอดูโปรนี้หน่อยค่ะ,ตอนนี้มีโปรแบบไหนบ้างคับ,ช่วงนี้ไม่มีโปรเหรอ,ช่วงนี้มีโปรอะไรบ้าง,ดูสินค้าพวกจัดโปร,มีโปรอีกมั้ย,มีโปรลดราคามั้ยคะ,หมดโปรยังคับ,โปรถึงเดือนไหน,รอโปรโมชั่นต่อไป,มีโปรดีๆป่าว,โปรหมดยังคับ,ตอนนี้มีโปรรึป่าวครับ,มีโปรมั้ยคับ,มีโปรไหมคับ,ช่วงนี้มีโปรลดราคาสินค้าบ้างหรือเปล่าคะ,ราคาแบบโปรใช่ไหมค่ะ,โปรโมชั่นเดือนนี้มีอะไรบ้างคะ,ตอนนี้มีโปรแบบไหนบ้างคับ,ขอดูโปรนี้หน่อยคะ,หมดโปรยัง,รอโปรโมชั่น,มีโปรดีๆป่าว,includes(โปรโมชัน),includes(โปรโมชั่น),includes(Promotion),includes(ส่วนลด),includes(มี&&โปร),includes(สอบถาม&&โปร),includes(ดู&&โปรโมชั่น),includes(สนใจ&&โปร),exacts(โปรโมชั่น),exacts(Promotion)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 3,
          count: 35,
          icon: '⏰',
          chip: '',
          label: 'Date/Business hours',
          new: true,
          intent: [
            {
              intentname: 'Template_วัน-เวลาทำการ',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ร้านเปิดทุกวันไหมคะ,ร้านเปิดมั้ยครับ,ร้านเปิดยังค่ะ,วันนี้ร้านเปิดรึเปล่าคะ,หน้าร้านเปิดกี่โมงนะคะ,พรุ่งนี้ร้านเปิดปกติใช่ไหมคะ,วันนี้ร้านเปิดมั้ยครับ,วันนี้ร้านเปิดมั้ยคะ,สวัสดีค่า วันนี้ร้านเปิดไหมค่า,ร้านปิดกี่โมงคะ,วันนี้ร้านปิดเหรอคะ,เปิดกี่โมงคะ,ปิดกี่โมงคะ,ร้านปิดกี่โมงคะ,includes(เวลา เปิด - ปิด),includes(เปิดกี่โมง),includes(ปิดกี่โมง),includes(เวลาเปิด),includes(เวลาปิด),includes(เปิด&&ตอนไหน),includes(ปิด&&ตอนไหน),includes(เปิด&&กี่โมง),includes(เปิด&&เวลา),includes(เปิด&&ยัง&&คะ),includes(เปิด&&ยัง&&ครับ),includes(เปิด&&เมื่อไหร่),includes(เปิด&&กี่&&โมง),includes(เวลา&&ร้าน&&เปิด),includes(เวลา&&ปิด),includes(ปิด&&เมื่อไหร่),exacts(เวลาเปิด),exacts(เวลาปิด),exacts(เวลาทำการ)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 4,
          count: 55,
          icon: '📞',
          chip: '',
          label: 'Telephone',
          new: true,
          intent: [
            {
              intentname: 'Template_เบอร์ติดต่อ',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ขอเบอร์ติดต่อด้วยคะ,ขอเบอร์โทรศัพท์หน่อยค่ะ,ขอเบอร์โทรครับ,ขอเบอร์โทรหน่อยครับ,ขอเบอร์โทรติดต่อหน่อยได้ไหมค่ะ,ติดต่อเบอร์ไหน,มีเบอร์ติดต่อกลับหากสินค้าชำรุดเสียหายมั๊ย,มีเบอร์ที่ติดต่อไหมครับ,มีเบอร์ไหม,เบอร์อะไรคะ,ขอเบอร์โทรครับ,ขอเบอร์ที่สามารถติดต่อเจ้าหน้าที่ได้,ขอทราบเบอร์โทรติดต่อหน่อยได้หรือป่าวครับ,ขอเบอร์คอลเซ็นเตอร์หน่อยครับ,ขอเบอร์หน่อยครับ,มีเบอร์ติดต่อมั้ยคับ,มีเบอร์ทางร้านมั้ยจะได้โทรคุย,รบกวรขอเบอร์โทรติดต่อโดยตรงก็ได้นะค่ะ,มีเบอร์โทรติดต่อรึเปล่าคะ,เบอร์โทรศัพท์เหรอครับ,รบกวนขอเบอร์ติดต่อได้ไหมคะ,รบกวนขอเบอร์โทรกลับด้วยครับ,ติดต่อที่ใหนครับมี เบอร์โทใหม,มีเบอร์โทรให้คำปรึกษาไหมครับ,มีเบอร์โทรมั้ยคะ,ขอเบอร์ได้ไหมครับไม่ค่อยเข้าใจ,ขอเบอร์หน่อยครับผมโทรเลยดีกว่า,ขอเบอร์โทรสอบถามหน่อยครับ,รบกวนขอเบอร์ติดต่อคับ,มีเบอร์ติดต่อไหมครับ อยากคุย,อยากได้เบอร์แอดค่ะ ได้ไหมคะ,ขอเบอร์แอดมินหน่อยคับ,ผมขอเป็นเบอร์โทรศัพย์,มีเบอร์ติดต่อไหมครับ,มีเบอร์โทรติดต่อไหมครับ,มีเบอร์น้องมั้ยเดี๋ยวพี่โทรถามดีกว่า,เบอร์ติดต่อพนักงานมั้ยค่ะ,ขอเบอร์ติดต่อครับผม ติดต่อคุณอะไรครับผม,ขอเบอร์โทรติดต่อหน่อยได้ไหมค่ะ,ขอเบอร์โทรหน่อยครับ,มีเบอร์ติดต่อไหมครับ,มีเบอร์ที่ติดต่อไหมครับ,includes(เบอร์ติดต่อ),includes(เบอร์&&ติดต่อ),includes(โทร&&ติดต่อ),includes(เบอ&&ติดต่อ),includes(โทร&&เบอร์),includes(ติดต่อ&&เบอร์&&ไหน),includes(ขอ&&เบอร์),includes(โทร&&ติดต่อ),includes(ขอ&&เบอ),includes(มี&&เบอร์&&ไหม),includes(โทร&&ได้&&ไหม),includes(โทร&&ได้&&มั้ย),exacts(เบอร์ติดต่อ),exacts(เบอร์โทร),exacts(การติดต่อ)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 5,
          count: 25,
          icon: '🙋‍♀️',
          chip: '',
          label: 'Contact admin',
          new: true,
          intent: [
            {
              intentname: 'Template_ติดต่อแอดมิน',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'รบกวนสอยถามแอดมินหน่อยค่ะ,รบกวน แอดมิน ตรวจสอบสินค้าให้หน่อย,สอบถามหน่อยครับแอดมิน,แอดมินติดตามของไห้หน่อยคะ,ขอคำแนะนำน่อยคับแอดมิน,ตอบหน่อยค่าแอดมิน,รบกวนแอดมิน แนะนำให้ด้วยครับ,แอดมินตอบด้วยนะคะ,แอดมินตอบช้ามาก,สอบถามแอดมิน,ติดต่อเจ้าหน้าที่,ยังไม่มีเจ้าหน้าที่อ่านเลยคะ,ไม่คุยกับบอท,includes(ติดต่อแอดมิน),includes(คุยกับแอดมิน),includes(ติดต่อเจ้าหน้าที่),includes(ติดต่อ&&admin),includes(contact&&admin),includes(คุยกับคน),includes(ไม่คุย&&บอท),includes(ไม่เอา&&บอท),includes(คุย&&เจ้าหน้าที่),exacts(ติดต่อแอดมิน),exacts(คุยกับแอดมิน),exacts(คุยกับคน),exacts(contact admin)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 6,
          count: 30,
          icon: '📍',
          chip: '',
          label: 'Store map',
          new: true,
          intent: [
            {
              intentname: 'Template_แผนที่ร้าน',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'สอบถามค่ะ แผนที่,ร้านอยุ่ตรงไหนนะ,ร้านอยุ่ตรงไหนนะ,ร้านอยู่ตรงไหนจ้ะ,รบกวนขอแผนที่หน่อยได้ไหมคะ,มีแผนที่ให้ไหมคะ,แอดมินส่งแผนที่ให้หน่อยค่ะ,ขอแผนที่ได้ไหมครับ,รบกวนส่งโลเคชั่นให้หน่อยครับ,เดินทางไปร้านยังไงคะ,วิธีการเดินทางไปร้าน,รบกวนขอตำแหน่งด้วยค่ะ,includes(แผนที่ร้าน),includes(ตำแหน่งร้าน),includes(อยู่&&ที่ไหน),includes(ไป&&อย่างไร),includes(ไป&&ยังไง),includes(วิธี&&เดินทาง),includes(ขอ&&แผนที่),includes(วิธี&&การไป),includes(ขอ&&โลเคชั่น),includes(มี&&แผนที่&&ไหม),includes(ขอ&&แผนที่&&หน่อย),includes(ร้าน&&อยู่ไหน),includes(ตำแหน่ง&&ร้าน),includes(การไปร้าน),includes(ไป&&อย่างไร),exacts(แผนที่ร้าน),exacts(ตำแหน่งร้าน),exacts(ที่อยู่ร้าน)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 7,
          count: 42,
          icon: '🛵',
          chip: '',
          label: 'Shipping cost',
          new: true,
          intent: [
            {
              intentname: 'Template_ค่าส่งสินค้า',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'รวมค่าส่งทั้งหมดเท่าไหร่คับ,เสียค่าส่งไหมค่ะ,โอนเสียค่าส่งไหม,รวมค่าส่งหรือยังครับ,รวมค่าส่งแล้วใช่มั๊ยคะ,ค่าส่งกี่บาทครับ,ค่าส่งลดได้ไหม,ไม่ฟรีค่าส่งหรือครับ,รวมค่าส่งเท่าไรคับ,ฟรีค่าส่งมั่ยครับ,คิดค่าส่งยังไงครับ,คิดค่าส่งไหม,ค่าส่งเท่าไหร่ค่ะ,รวมค่าส่งยังคับ,มีค่าส่งไหมค่ะ,โอนมีค่าส่งไหมค่ะ,โอนนี่ฟรีค่าส่งมั้ยครับ,เสียค่าส่งมั้ยค่ะ,ส่งฟรี หรือ มีบวกค่าส่งค่ะ,ถ้าโอนเสียค่าส่งไหมคับ,ค่าส่งเท่าไหร,ค่าส่งเท่าไหร่ค่ะ,สรุปว่ามีค่าส่งมั้ยค่ะ,เสียค่าส่งไหมคะ,ถ้าโอนลดค่าส่งไหมครับ,ทำใมคิค่าส่งด้วย,โอนมีค่าส่งไหมคะ,มีค่าส่งเพิ่มไหม,ไม่ฟรีค่าส่งเหรอคะ,โอนไม่มีค่าส่งเปล่า,โอนจ่ายรวมค่าส่งเท่าไหร่ครับ,รวมค่าส่งยังครับ,includes(ค่าส่ง&&เท่าไหร่),includes(ขอ&&ค่าส่ง),includes(ราคา&&ค่าส่ง),includes(ค่าส่ง&&สินค้า),includes(เสีย&&ค่าส่ง&&ไหม),includes(เสีย&&ค่าส่ง&&มั้ย),includes(ค่าส่ง&&กี่บาท),includes(ฟรี&&ค่าส่ง),includes(สอบถาม&&ค่าส่ง),includes(เรท&&ค่าส่ง),exacts(ค่าส่ง)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 8,
          count: 35,
          icon: '📲',
          chip: '',
          label: 'Account number',
          new: true,
          intent: [
            {
              intentname: 'Template_เลขบัญชี',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'พร้อมโอนค่ะ,พร้อมโอนครับ,แบบโอนคับ,เลขโอนเข้า,ขอโอนแระกันค่า,วันนี้โอนบัญชีเงินได้ไหม,สะดวกโอนได้ป่าว,ขอโอนนะครับ,จะโอนเลยขอบัญชีด้วย,ขอบัญชีคะ,ขอบัญชีครับ,โอนบัญชีไหนครับ,ขอเลขที่บัญชีครับ,ขอเลขที่บัญชีค่ะ,บัญชีนี้นะครับ,บัญชีมาค่ะ,ขอบัญชีชื่ออะไร,ขอโทษด้วย ขอโอนบัญชีได้ไหม,ขอเลขที่บัญชีค่ะ,ขอเลขที่ บช,มีเลข บัญชีไหมคับ,includes(เลข&&บัญชี),includes(โอน&&ยังไง),includes(โอน&&ที่ไหน),includes(ขอ&&เลข&&บัญชี),includes(ขอ&&เลข&&บช),includes(โอน&&ยังไง),includes(โอน&&อย่างไร),includes(โอน&&บช),includes(พร้อม&&โอน),includes(ธนาคาร&&อะไร),includes(ขอ&&บัญชี),includes(ขอ&&บันชี),exacts(เลขบัญชี)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 9,
          count: 60,
          icon: '🚛',
          chip: '',
          label: 'Cash on delivery',
          new: true,
          intent: [
            {
              intentname: 'Template_เก็บเงินปลายทาง',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'เก็บปลายทางมีค่าส่งมั้ยค่ะ,รวมค่าส่งปลายทางเท่าไหร่ค่ะ,สนใจ เก็บปลายทางนะคะ,ค่าส่งเก็บปลายทางเท่าไหร่คะ,เก็บเงินปลายทางมีค่าส่งหรือเปล่าครับ,เก็บปลายทางเท่าไรค่ะ,เก็บปลายทางบวกเพิ่มไหมคะ,เก็บปลายทางอย่างเดียวใช่มั๊ยคับ,ส่งปลายทาง,อันนี้เก็บปลายทางไมคะ,สรุปชำระเงินปลายทางเท่าไหร,จ่ายเงินปลายทางคับ,ชำระปลายทางคับ,ชำระเงินปลายทางครับ,ชำระแบบเก็บเงินปลายทางครับ,พร้อมส่งปลายทางเท่าไหร่ครับ,รวมเท่าไรปลายทางครับ,รับค่ะเก็บปลายทาง,ราคารวมปลายทางเท่าใหร่,ราคารวมเก็บเงินปลายทางยังคับ,แบบเก็บเงินปลายทางใช่มั้ยครับ,เอาปลายทางคับ,ชำระปลายทางครับ,มีแบบชำระปลายทางมั้ยคะ,รับคะ ปลายทาง,เก็บปลายทางอย่างเดียวใช่ไหมคะ,มีบริการเก็บปลายทางไหมคะ,ยอดจ่ายปลายทางเท่าไหร่คะ,มีบริการเก็บปลายทางไหมค่ะ,จ่ายปลายทาง,เก็บปลายทางได้ใช่มั้ยคะ,เก็บเงินปลายทางมีบวกเพิ่มไหมครับ,ได้ครับเก็บเงินปลายทางครับ,เก็บเงินปลายทาง รวมส่งเท่าไหร่ครับ,จ่ายปลายทางไหมคับ,จัดส่ง เก็บเงินปลายทางครับ,ชำระปลายทาง,จ่ายปลายทางครับ,มีบริการเก็บเงินปลายทางไหม,เอาเก็บปลายทางครับ,เอาแบบเก็บเงินปลายทางค่ะ,เก็บเงินปลายทางราคาเดียวกันหรือเปล่าครับ,เก็บเงินปลายทางอย่างเดียวใช่มัยคะ,เก็บปลายทางเท่าไหร่คับ,เก็บปลายทางครับ,สั่งแบบเก็บเงินปลายทางค่ะ,เก็บเงินปลายทาง บวกเพิ่มหรือเปล่า,เป็นบริการปลายทางใช่ไหมคะ,includes(มี&&ปลายทาง),includes(เก็บเงินปลายทาง),includes(เก็บ&&ปลายทาง),includes(จ่าย&&ปลายทาง),includes(มี&&ปลายทาง),includes(ปลายทาง&&ได้ไหม),includes(ปลายทาง&&ได้มั้ย),includes(ชำระ&&ปลายทาง),includes(บริการ&&ปลายทาง),includes(ราคา&&ปลายทาง),includes(เก็บ&&ปายทาง),includes(บวกเพิ่ม&&ปลายทาง),includes(ปลายทาง&&เท่าไหร่),exacts(เก็บเงินปลายทาง),exacts(COD)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 10,
          count: 30,
          icon: '💳',
          chip: '',
          label: 'Pay via Credit card',
          new: true,
          intent: [
            {
              intentname: 'Template_ชำระผ่านบัตรเครดิต',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'จ่ายผ่านบัตรเครดิตได้ไหมคะ,จ่ายบัตร credit ได้หรือไม่,ที่ร้านรับบัตรเครดิตไหมคะ,จ่ายด้วยบัตรเครดิตค่ะ,ตัดผ่านบัตรเครดิตได้มั้ยค่ะ,จ่ายผ่านบัตรค่ะ,ถ้าตัดบัตรเครดิต มีไหมคะ,จะชำระผ่านบัตรเลยได้ไหมครับ,ชำระผ่านบัตรเครดิตได้มั้ยหรือโอนครับ,พอมีช่องทางชำระผ่านบัตรมั้ยครับ,มีบริการตัดผ่านบัตรเครดิตมั้ยค่ะ,ใช้บัตรเครดิตจ่ายได้มั้ยคะ,ใช้บัตรเครดิตได้มั้ยคะ,มีบริการตัดผ่านบัตรเครดิตมั้ยค่ะ,จ่ายผ่านบัตรเครดิตได้หรือเปล่าค่ะ,ตัดบัตรได้ไหมคะ,includes(บัตรเครดิต),includes(ตัดบัตร),includes(จ่าย&&บัตร),includes(ตัด&&เครดิต),includes(รับ&&บัตร&&ไหม),includes(รับ&&บัตร&&มั้ย),includes(ชำระ&&ผ่าน&&บัตร),includes(ใช้&&บัตร&&เครดิต),includes(ใช้บัตร&&ได้ไหม),includes(ใช้&&บัตร&&ได้มั้ย),includes(บริการ&&ตัดบัตร),includes(บริการ&&บัตร),includes(ตัดบัตร&&ได้มั้ย),includes(ตัดบัตร&&ได้ไหม),includes(จ่าย&&ด้วย&&บัตร),exacts(บัตรเครดิต),exacts(บัตรเดบิด)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 11,
          count: 42,
          icon: '💰',
          chip: '',
          label: 'Pay by Installments',
          new: true,
          intent: [
            {
              intentname: 'Template_การผ่อนชำระ',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ขอดูโปรผ่อนค่ะ,ขอแบบผ่อนจ่าย,ผ่อนจ่ายนี่รายละเอียดยังไงคะ,ผ่อนบัตรเครดิตได้ใช่ไหมคะ,ผ่อนเงินสดคะ,ผ่อนเดือนเท่าไหร่คะพี่,ผ่อนแบบโอน เป็นยังไงครับ,ผ่อนแบบไม่ใช้บัตร ได้ไหมครับ,ผ่อนได้ไหมครับ,มีผ่อนแบบไม่รูดบัตรไหมคะ,สามารถผ่อนแบบไหนได้บ้างหรอครับ,ผ่อน เดบิต ก็ได้ใช่ไหมคะ,อยากผ่อนชำระ แต่ไม่มีบัตรเดบิตเลยค่ะ,ไม่ทราบว่ามีผ่อนจ่ายไหมครับ,คือผ่อนตรงกับทางคุณเลยใช่ไหมคะ,ต้องผ่อนผ่านบัตรใช่ไหมครับ,ต้องผ่อนกี่เดือนครับ,จ่ายเงินสดมีแบบผ่อนด้วยใช่ไหมค่พ,ต้องผ่อนผ่านบัตรใช่ไหมครับ,มีผ่อนชำระมั้ยคะ,มีผ่อนบัตร เครดิตมั้ยครับ,ผ่อนบัตรเครดิต,มีแบบผ่อนชำระไหมครับ,รูดบัตร หรือ ผ่อนได้มั๊ยคะ,มีโปรพิเศษหรือผ่อนอะไรไหมครับ,includes(การ&&ผ่อน),includes(ผ่อน&&ได้ไหม),includes(ผ่อน&&ได้มั้ย),includes(มี&&ผ่อน&&ไหม),includes(มี&&ผ่อน&&มั้ย),includes(ผ่อน&&ผ่านบัตร),includes(ผ่อน&&เงินสด),includes(รายละเอียด&&ผ่อน),includes(ข้อมูล&&ผ่อน),includes(สนใจ&&ผ่อน),includes(ต้องการ&&ผ่อน),includes(อยาก&&ผ่อน),includes(ขอ&&ผ่อน),includes(โปร&&ผ่อน),includes(ผ่อน&&ชำระ),includes(ผ่อน&&ไม่ใช้&&บัตร),includes(มี&&ผ่อน&&ไหม),includes(มี&&ผ่อน&&มั้ย),includes(ผ่อน&&ชำระ),exacts(การผ่อน)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 12,
          count: 66,
          icon: '🎁',
          chip: '',
          label: 'Delivery cycle/Transportation channel',
          new: true,
          intent: [
            {
              intentname: 'Template_รอบการจัดส่ง',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ส่งของ บริษัทอะไรครับ,ส่งของวันไหน,ส่งของจะติดเสาร-อาทิตไหมคะ,ไม่ทราบส่งของให้ผมหรือยังครับ,ส่งของหรือยังคะ ขอเลขพัสดุหน่อยค่า,ส่งของบริษัทอรัยครับ,ขนส่งของcjหรอค่ะ,รบกวนหน่อยคะ ส่งของหรือยังคะ,ใช้เวลากี่วันในการส่งของ,ได้ส่งของแล้วใช่ไหมคะ,พี่ครับพี่ส่งของให้ผมรึยังคับ,วันไหนคะที่จะส่งของ,ชำระเงินแล้ว ส่งของมายังครับ,ขออนุญาตสอบถามครับ ส่งของรึยังครับผม,สอบถามหน่อยค่า ส่งของให้วันไหนคะ, ส่งของวันไหนคะ,ส่งของได้เมื่อไหร่ครับ,แอด ส่งของวันไหนคะ,ไม่ทราบว่าทำการจัดส่งของหรือยังคับ,ไม่ทราบว่าได้ส่งของมาหรือยังค๊า,มิทราบว่าจะจัดนำส่งของวันไหนคะ,พี่ส่งของยังครับ,ส่งของวันไหนคะ ขนส่งอะไรคะ,ว่าส่งของมาหรือยัง,ขอเลขส่งของด้วยค่ะ,ส่งของให้ยังครับ,ส่งของมารึยังคะ,ใช้ขนส่งของอะไรครับ,ใช้ขนส่งอะไรคะ,ส่งขนส่งไรครับ,ส่ง ขนส่งอะไรคะ,ยากทราบว่าบริษัทไหนขนส่ง,ขนส่งอะไรเอ่ย,ขนส่งเดียวกันไหมคะ,ขนส่งอะไรคะ,ส่ง EMS หรือขนส่งเอกชนครับ,ส่ง ขนส่ง เอกชนน่ะ,สอบถามค่ะ ขนส่งของอะไรคะ, ส่งขนส่งอะไรให้ผมครับ,ใช้ขนส่งอะไรครับ,ของถึงวันไหน เช็คยังไงคับ,จะเริ่มส่งของวันไหนคับ,กีวันได้รับ,กี่วันได้รับของค่ะ,ส่งของได้รับประมาณกี่วันคะ,includes(ส่ง&&วันไหน),includes(ส่ง&&เมื่อไหร่),includes(ส่ง&&ตอนไหน),includes(ขนส่ง&&อะไร),includes(ส่ง&&ของ&&ยัง),includes(ส่ง&&เมื่อใด),includes(ส่งของ&&แล้ว&&ไหม),includes(ขนส่ง&&ของ&&อะไร),includes(บริการ&&ขนส่ง),includes(ช่องทาง&&ขนส่ง),includes(ขนส่ง&&เจ้าไหน),includes(ขนส่ง&&แบรนด์ไหน),includes(กี่วัน&&ได้ของ),includes(รอของ&&กี่วัน),includes(เริ่มส่ง&&วันไหน),includes(ส่งของ&&วันไหน),includes(จัดส่ง&&หรือยัง),includes(จัดส่ง&&เมื่อไหร่),includes(บริษัท&&ขนส่ง),includes(ขนส่ง&&ของ&&ที่ไหน),includes(กี่วัน&&ได้ของ),includes(กี่วัน&&ได้รับ),includes(รอ&&กี่วัน&&ส่ง)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 13,
          count: 85,
          icon: '📦',
          chip: '',
          label: 'Ask for Parcel Number',
          new: true,
          intent: [
            {
              intentname: 'Template_ขอเลขพัสดุ',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ขอหมายเลขของ,ขอหมายเลขพัสดุหน่อยครับ,ขอเลขพัสดุหน่อยครับ,ขอเลขแทรคได้มั้ยคะ,จัดส่งแล้วขอเลขพัสดุด้วยนะคะ,มีเลขแทคให้เช็คมั้ยค่ะ,ยังไม่มีเลขที่พัสดุมาให้เลย,รอเลขพัสดุให้ดูด้วย,รบกวนขอเลขพัสดุหน่อยครับ อยากเช็คสถานะ,ส่งเลขที่พัสดุมาเลยครับ,ขอเลขพัสดุให้หน่อยอย่าลืมนะ,ขอเลขเช็คพัสดุหน่อยค่ะ,ขอเลขที่พัสดุด้วยนะคะ,ขอเลขพัสดุด้วย,ขอเลข บช,ขอเลขพัสดุหน่อยครับ,จะทราบเลขพัสดุได้จากที่ไหนคะ,อยากทราบเลขพัสดุที่สั่งครับ,ขอเลขพัสดุหน่อยจ้า,ขอเลขที่ส่งสินค้าด้วยครับ,ขอเลขพัสดุด้วย,เช็คเลขพัสดุให้ผมดูหน่อยครับ,ส่งแล้วแจ้งเลขทีนะคับ,หรือมีเลขแทรค รบกวนแจ้งทีจ้า,ส่งของหรือยังคะ ขอเลขพัสดุหน่อยค่า,รอจ้า ยังไงช่วยแจ้งเลขทีนะคับ,เลขพัสดุเช็คยังไงคะ ?,เอาเลขพัสดุเช็คที่ไหนครับ,แจ้งเลขที่พัสดุด้วยนะครับ,ขอเลขที่เช็คพัสดุด้วยครับ,ขอหมายเลขพัสดุด้วยครับ,ขอเลขพัสดุด้วยคับ,ขอเลขพัสดุด้วยนะครับ,พี่ดูเลขพัสดุได้ที่ไหน,ไม่แจ้งเลขพัสดุหรอคะพี่แอดมิน,ไม่เห็นมีเลขแทรคส่งให้เลยสงสัยคะ,ได้เลขพัสดุแล้วช่วยส่งให้พี่ด้วยนะคะ,สอบถามเลขพัสดุสินค้าหน่อยครับ,สอบถามขอเลขพัสดุหน่อย,ขอเลขส่งของด้วยค่ะ,ขอเลขพัสดุด้วยคะ,จะมีเลขพัสดุให้ช่ายมั๊ยคะ,ขอเลขจัดส่งหน่อยค่า,ขอหมายเลขพัสดุด้วยนะคะ,เลขพัสดุก็ยังไม่ได้,รบกวนของเลขส่งครับ,รบกวนขอหมายเลขพัสดุด้วยครับ,มีหมายเลขพัสดุ เช็คสถานะมั้ยครับ,มีเลขติดตามพัสดุไหมครับ,รบกวนขอหมายเลขพัสดุด้วยครับ,ขอเลขแทร็คค่ะ,มีเลขแทร็คไหมคะ เช็คพัสดุ,สรุปจะเช็คเลขพัสดุยังไงค่ะ,ถ้าส่งมาแล้ว ขอเลขพัสดุ ด้วยนะครับ,ถ้าส่งแล้วแจ้งเลขแทร็คในนี้ให้หน่อยนะคะ,จัดส่งรึยังครับรบกวนขอเลขพัสดุด้วยครับ,ส่งแล้วส่งเลขพัสดุให้ด้วยนะครับ,แจ้ง เลขได้วันไหนครับ,ขอหมายเลขพัสดุหน่อยค่ะ,ขอเลขเช็ค ของหน่อยคะ,ทำไมเช็คเลขไม่ได้,รบกวนขอเลขพัสดุค่ะ,รบกวนขอเลขพัสดุหน่อยค่ะ,มีเลขพัสดุให้เช็คมั้ยค่ะ,มีเลขพัสดุไหมครับ,เลขพัสดุมีมั้ยครับ,มายังเลข ems,ถ้าส่งมาแล้ว ขอ เลขพัสดุด้วยนะคับ,ขอหมายเลขพัสดุหน่อยค่ะ,ขอเลขพัสดุคะ,เสร็จแล้ว แจ้งเลข มาครับ,เช็คเลขวัสดุให้หน่อยได้ไหมครับ,ส่งยังคงรับขอเลขหน่อย,includes(เลขพัสดุ),includes(ขอเลข&&พัสดุ),includes(เช็ค&&พัสดุ),includes(เช็ค&&เลข&&ที่ไหน),includes(เช็ค&&เลข&&ยังไง),includes(ตรวจสอบ&&เลข),includes(ตรวจสอบ&&พัสดุ),includes(ขอเลข&&พัสดุ),includes(แจ้ง&&เลข&&พัสดุ),includes(เช็ค&&เลข),includes(หมายเลข&&พัสดุ),includes(เช็ค&&สถานะ&&พัสดุ),includes(สถานะ&&พัสดุ),exacts(เลขพัสดุ)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 14,
          count: 16,
          icon: '🏪',
          chip: '',
          label: 'Storefront',
          new: true,
          intent: [
            {
              intentname: 'Template_หน้าร้าน',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ซื้อผ่านหน้าร้าน,มีหน้าร้านใหมคับ,หน้าร้านอยู่แถวไหนครับ,หน้าร้านอยู่ไหนคับ,มีหน้าร้านไหมค่ะ,มีหน้าร้านไหมครับ,มีรับหน้าร้านไหมครับ,มีหน้าร้านหรือป่าวค่ะ,มีหน้าร้านไหมครับ ถ้ามี มีที่ไหนบ้างครับ,มีหน้าร้านมั้ยคะ พอดีรีบใช้ค่ะ,มีหน้าร้านไหม,มีหน้าร้านมั้ย,includes(มี&&หน้าร้าน),includes(หน้าร้าน&&อยู่ไหน),includes(รับ&&หน้าร้าน),includes(ซื้อ&&หน้าร้าน),includes(ไป&&หน้าร้าน),exacts(หน้าร้าน)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 15,
          count: 15,
          icon: '🎉',
          chip: '',
          label: 'Ask for review',
          new: true,
          intent: [
            {
              intentname: 'Template_ขอดูรีวิว',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'มีรีวิวมั้ยครับ,มีรีวิวไหมคับ,มีรีวิวหน่อยค่ะ,มีรีวิวไม่คะ,มีรีวิวลูกค้ามั้ยคะ,มีคลิปรีวิวสินค้าไหมคะ,มีคลิปรีวิวมั้ยค่ะ,includes(ขอ&&รีวิว),includes(รีวิว&&เพิ่มเติม),includes(รีวิว&&ทั้งหมด),includes(ขอ&&รีวิว&&หน่อย),includes(รูป&&รีวิว),includes(คนใช้&&จริง),includes(รีวิว&&เพิ่มเติม),includes(ดู&&review),includes(ขอ&&review),exacts(รีวิว)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 16,
          count: 62,
          icon: '📣',
          chip: '',
          label: 'Wholesale Price',
          new: true,
          intent: [
            {
              intentname: 'Template_ราคาส่ง',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'มีราคาส่งไหมครับ,มีเรทราคาส่งมั้ยคะ,ขอราคาส่งค่ะ,ที่บอกสั่งเยอะมีราคาส่ง เยอะแค่ไหนคับ,มีราคาส่งสำหรับร้านค้าไหมครับ,มีราคาส่งไหมครับ,ราคาส่งจะนำมาจำหน่ายต่อคิดยังไงครับ,ขายส่งไมคะ,มีขายส่งใหมครับ,ปกติขายส่งด้วยไหมครับ,ขอดูงานราคาส่งค่ะ,ขอดูเรทราคาส่งหน่อยค่ะ,ขอทราบเรทราคาส่งค่ะ,ขอราคาส่งหน่อยจ้า,ขอรายละเอียด ราคาส่งคะ,ขอเรทราคาส่งค่ะ,ขอเรทราคาส่งจ้า,ต้องรับกี่ตัวถึงได้ราคาส่งคะ,ราคาส่งต้องสั่งกี่ตัวคะ,ราคาส่งต้องเอากี่ตัวขึ้นไปค่ะ,ราคาส่งราคาเท่าไหร่ค่ะ,ราคาส่งเท่าไรค่ะ,ราคาส่งเท่าไหร่,ราคาส่งเท่าไหร่ครับ,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สนใจซื้อราคาส่งมาขายจ้า,สนใจราคาส่งค่ะ,สนใจสินค้าราคาส่งค่ะ,สนใจเรทราคาส่งค่ะ,อบถามราคาส่งหน่อยจ้า,สอบถามราคาส่งจ้า,สอบถามเรทราคาส่งค่ะ สำหรับรับมาขายค่ะ,สินค้าขายราคาส่งยังไงคะ,อยากสอบถามว่าถ้าเราจะรับไปขาย ราคาส่งอย่างไรค่ะ,แล้วมีราคาส่งมั้ยค่ะ,ขอรายละเอียด ราคาส่งคะ,ถ้าราคาขายส่งต้องสั่งกี่ชุดอ่ะคะ,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สอบถามรายละเอียดขายส่งค่ะ,ขายส่งมีราคาแบบไหนบ้างคะ,สนใจขายส่ง ส่งยังงัยคะ,ราคาขายส่งคิดยังไงคะ,สอบถามรายละเอียดขายส่งค่ะ,กำลังหาร้านขายส่ง,ขายส่งอย่างเดียวใช่ไหมค่ะ,ขายส่งมีราคาแบบไหนบ้างคะ,ราคาขายส่งชุดละเท่าไหร่,ราคาส่งเท่าไหร่ค่ะ ขายส่ง,สนใจซื้อแบบขายส่งค่ะ มีเรทเท่าไหร่บ้างจ้า,includes(เรท&&ราคา&&ส่ง),includes(ราคา&&ส่ง),includes(เรท&&ขายส่ง),includes(สนใจ&&ขายส่ง),includes(ซื้อ&&ขายส่ง),includes(ราคาส่ง),includes(ขอเรท&&ส่ง),includes(รับ&&ขายส่ง),includes(เรท&&ราคา&&ส่ง),includes(ขายส่ง&&ไหม),includes(ขายส่ง&&มั้ย),includes(รายละเอียด&&ขายส่ง),includes(เรท&&ราคา&&ส่ง),includes(สอบถาม&&ขายส่ง),includes(สอบถาม&&เรทส่ง),exacts(ราคาส่ง)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 17,
          count: 72,
          icon: '💯',
          chip: '',
          label: 'Product warranty/Product replacement/Product claim',
          new: true,
          intent: [
            {
              intentname: 'Template_การรับประกันสินค้า',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'การรับประกันควรทำอย่างไร,รับประกันกี่ปีคับ,มีใบรับประกันให้ด้วยใช่ไหมค่ะ,มีรับประกันสินค้ามั๊ย,มีรับประกันไหมครับ,มีรับประกันไหมค่ะ,รับประกันกี่ปีครับ,รับประกันสินค้าไหมคะ,รับประกันหรือป่าวครับ,รับประกันไหม,สินค้ามีรับประกันใช่มั๊ย,สินค้ารับประกันไหมครับ,ใบรับประกันจะกรอกยังไงคับ,ตัวนี้มีการรับประกันมั้ยครับ,ตัวนี้มีประกันไหมคะ,มีปัญหาติดต่อประกันที่ไหนครับ,มีรับประกันกี่ปีครับ,มีรับประกันมัยค่ะ,มีรับประกันมั้ยค่ะ,มีเงื่อนในการรับประกันไหมคับ,รับประกัน กี่ปีคะ,รับประกันกี่ปีคับ,รับประกันกี่ปีค่ะ ?,รับประกันคุณภาพสินค้ามั้ยครับ,รับประกันด้วยหรอคับ,รับประกันมั้ยครับ,รับประกันยังไงคะ,รุ่นนี้มีประกันมั้ยคะ,สินค้ามีประกันกี่ปีครับ,สินค้ามีประกันมั้ยคะ,สินค้ารับประกันนานเท่าไหร่คับ,แล้วประกันสินค้า,สินค้ารับประกัน กี่ปีครับ,รับประกันรับประกัน1ปี?,รับประกันสินค้าด้วยไหมคะ,สินค้ารับประกันไหม,รับประกันเท่าไหร่ครับ,รับประกันเครื่องไหมและกี่ปีค่ะ,ใบรับประกันมีมั้ยครับ,มีรับประกันด้วยมั้ยค่ะ,มีรับประกันตังเครื่องไหมคะ, มีรับประกันใช่มั่ยครับ,มีรับประกันใช้ใหมคับ,รับประกันสินค้าหรือป่าวครับ,รับประกันยังไงครับ,ประกันความเสียหายยังคับ,รับประกันยังไงคับ,รับประกันสินค้าไม่,รับประกันหรือเปล่าครับ,รับประกันเครื่องมั้ยค่ะ,รับประกันไมค่ะ,สินค้ารับประกันรึเปล่าคะ,สินค้ารับประกันนาน??,รับประกันกี่เดือนครับ,รับประกันยังไง,รับประกันกี่ปีคับ,รับประกันกี่ปีคะ,includes(การรับประกัน),includes(ประกันสินค้า),includes(รับประกัน),includes(ประกัน&&เท่าไหร่),includes(ประกัน&&เดือน),includes(ประกัน&&ปี),includes(ประกัน&&สินค้า),includes(ใบรับประกัน),includes(ประกัน&&นาน&&แค่ไหน),includes(รับประกัน&&ยังไง),includes(รับประกัน&&อย่างไร),includes(สินค้า&&มี&&ประกัน),includes(ประกัน&&ของ&&สินค้า),includes(รับประกัน&&มั้ย),includes(รับประกัน&&ไหม)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 18,
          count: 35,
          icon: '💞',
          chip: '',
          label: 'Received the product',
          new: true,
          intent: [
            {
              intentname: 'Template_ได้รับสินค้า',
              q_type: 'text',
              a_type: 'json',
              q_val:
                'ได้รับของเรียบร้อยแล้วค่ะ,ได้รับสินค้าแล้วนะคะ,ได้รับของแล้ว ชุดสวยมากคะ ไว้อุดหนุนไหม่นะคะ,ได้รับของแล้วคร้า,ได้รับของแล้วคะ,ได้รับของแล้วค่ะ,ได้รับของแล้วค่ะสวยถูกใจเลยค่ะ,ได้รับของแล้วค่า,ได้รับของแล้วนะ,ด้รับของแล้วนะคะของน่ารักมาก,ได้รับของแล้วนะคะ,ได้รับของแล้วนะคะส่งไวมากคะ,ได้รับแล้วนะค่ะ,ได้รับแล้วนะคะสวยมากค่ะตรงปกด้วย,ได้รับสินค้าแล้วนะค่ะ,ได้รับสินค้าแล้วค่ะ,ได้รับของเรียบร้อยค่ะ,ได้รับของแล้วค่ะ ขอบคุนนะคะ,ได้รับของแล้วนะคะ,ได้รับของแล้วค่ะ,ได้รับสินค้าแล้วค่ะ,ได้รับสินค้าแล้วค่ะสวยค่ะ,ได้รับสินค้าแล้วนะคะ ตรงปกทุกชุดค่ะ,ได้รับแล้ว,ได้รับแล้วนะคะ,ได้รับของแล้วนะคะเนื้อผ้าดีมากสวยมากค่ะ,ได้รับสินค้าแล้วน่ะคะ..สวยทุกตัวเลย,ชอบมากคะสวยมาก,ชอบมากค่ะ,includes(ได้รับ&&แล้ว),includes(รับ&&สินค้า&&แล้ว),includes(ถูกใจ&&มากเลย),includes(สินค้า&&ดีมาก),includes(ได้รับ&&ของ&&แล้ว),includes(ของ&&มาส่ง&&แล้ว),includes(ได้รับแล้ว)',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 19,
          count: 0,
          icon: '📞',
          chip: '',
          label: 'Customer Informs phone number',
          new: true,
          intent: [
            {
              intentname: 'Template_ลูกค้าแจ้งเบอร์โทร',
              q_type: 'text',
              a_type: 'json',
              q_val: '{phone}',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 20,
          count: 0,
          icon: '🏠',
          chip: '',
          label: 'Customer Informs the address',
          new: true,
          intent: [
            {
              intentname: 'Template_ลูกค้าแจ้งที่อยู่',
              q_type: 'text',
              a_type: 'json',
              q_val: '{address}',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        },
        {
          id: 21,
          count: 0,
          icon: '🌎',
          chip: '',
          label: 'Customers Inform the province',
          new: true,
          intent: [
            {
              intentname: 'Template_ลูกค้าแจ้งจังหวัด',
              q_type: 'text',
              a_type: 'json',
              q_val: '{province}',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              postidlist: '',
              userstatus: '',
              usertags: '',
              isShow: true,
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    filterTemplateIntent() {
      return this.templateIntent.filter(item => {
        return this.$t(item.label)
          .toLowerCase()
          .includes(this.search.toLowerCase())
      })
    }
  },
  async mounted() {},
  methods: {
    openModal: function() {
      var vm = this
      vm.showTransfer = true
      if (vm.currentPage) {
        vm.loading = true
      } else {
        vm.loading = false
      }
    },

    select: function(intent) {
      var vm = this
      intent[0].pageid = this.selectedBot.pageid.toString()
      var boo = this.intents.filter(item => {
        return item.intentname === intent[0].intentname
      })
      vm.$swal
        .fire({
          title: vm.$t(`คุณต้องการเพิ่มบทสนทนาหัวข้อ ${intent[0].intentname} สำหรับเพจของคุณ`),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          vm.$store.dispatch('loading')
          if (result.value) {
            if (boo.length !== 0) {
              vm.$store.dispatch('loading')
              vm.$swal.fire({
                title:
                  vm.$t('conversation') +
                  ' "' +
                  intent[0].intentname.replace(/\<|\>/g, '') +
                  '" ' +
                  'ซ้ำ',
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
            } else {
              let intentItem = { ...intent[0], onlytime: false }
              api.addIntent(intentItem, function(error, response) {
                if (error) {
                  if (response.result === 'DUPLICATE_INTENT_NAME') {
                    vm.$swal({
                      title: vm.$t('Error'),
                      type: 'error',
                      text: vm.$t('duplicate_conversation_name'),
                      confirmButtonText: vm.$t('Confirm')
                    })
                  }
                  vm.$store.dispatch('loading')
                  return
                }
                Object.assign(intentItem, { id: response.id.toString() })
                vm.$store.commit('SET_INTENT', intentItem)
                vm.showTransfer = false
                vm.$swal
                  .fire({
                    title:
                      vm.$t('conversation') +
                      ' "' +
                      intentItem.intentname.replace(/\<|\>/g, '') +
                      '" ' +
                      vm.$t('added'),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                  .then(response => {
                    if (response.value) {
                      vm.$emit('goto', intentItem.id)
                      // window.location.reload()
                    }
                  })
                vm.$nextTick(() => {
                  vm.$store.dispatch('loading')
                })
              })
            }
          } else {
            vm.$store.dispatch('loading')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  background-color: aliceblue;
  padding: 10px;
  border-radius: 50%;
}
.chip {
  float: right;
  bottom: 12px;
  color: darkgray;
  pointer-events: none;
  background: #f0f0f0;
}
.btn-select {
  float: right;
  margin-top: -13px;
}
.small {
  position: absolute;
  padding: 0px 4px;
  color: palevioletred;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/TemplateIntent.vue